import React, { useState, useEffect } from "react";
import { QRCode } from "react-qrcode-logo";
import Logo from "./../../assets/img/logo.png";
import { generateQRcodeAction } from "../../actions/PublicFormsActions";
import { Button, Modal, Form } from "react-bootstrap";
import { connect } from "react-redux";
import UrlConstants from "../../config/UrlConstants";

function GenerateQRcode({
  generateQRcodeAction,
  showQRcodePrompt,
  handleCloseQRcodePrompt,
  transaction,
  formType,
}) {
  const [qValue, setQValue] = useState("");
  const [isBlankForm, setIsBlankForm] = useState(true);
  const [knowAboutUs, setKnowAboutUs] = useState("");
  const [formInputFlag, setFormInputFlag] = useState(false);

  useEffect(() => {
    if (showQRcodePrompt) {
      setIsBlankForm(true);
      setKnowAboutUs("");
    }
  }, [showQRcodePrompt]);

  const qSize = 300;
  const qLogoHeight = qSize * 0.5;
  const qLogoWidth = qSize * 0.5;
  const qBgColor = "#379143";

  const handleClick = () => {
    //Setup the filename
    const dt = new Date();
    let filestamp =
      "_" +
      dt.getFullYear().toString() +
      (dt.getMonth() + 1).toString() +
      dt.getDate().toString() +
      dt.getHours().toString() +
      dt.getMinutes().toString() +
      dt.getSeconds().toString();
    let fileName =
      formType +
      "_QRcode" +
      // (transaction && transaction.clientName
      //   ? "_" + transaction.clientName
      //   : "") +
      filestamp +
      ".png";
    let fn = fileName.split(" ").join("_");

    const canvas = document.querySelector(".HpQrcode > canvas");
    const downloadLink = document.createElement("a");
    downloadLink.href = canvas.toDataURL();
    downloadLink.download = fn;
    downloadLink.click();
  };

  function generateQRcode() {
    let newPublicForm = {
      form: formType,
      transactionId: transaction.id,
      // expiresOn: new Date(moment(appoinmentDate).subtract(5, "days")),
      auth: false,
      isBlankForm: isBlankForm,
      knowAboutUs: knowAboutUs,
    };

    generateQRcodeAction(newPublicForm).then((res) => {
      let url = UrlConstants.createQRcodeUrl
        .replace("{publicFormId}", res._id)
        .replace("{token}", res.token);
      // console.log("generateQRcodeAction url", url);
      setQValue(url);
    });
  }

  return (
    <>
      <Modal
        show={showQRcodePrompt}
        onHide={() => handleCloseQRcodePrompt()}
        dialogClassName="modal-90w"
        className="modal-med modal-400"
        centered
        backdrop={false}
        style={
          window.innerWidth > 800
            ? ""
            : { width: "380px", transform: "translateY(-120px)" }
        }
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            QR Code
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0">
          <div>
            {!formInputFlag ? (
              <form>
                <div className="form-group">
                  <Form.Label>How did you hear about us?</Form.Label>
                  <Form.Control
                    name="knowAboutUs"
                    onChange={(e) => {
                      setKnowAboutUs(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group">
                  <Form.Check
                    name="isBlankForm"
                    className="d-inline mr-2"
                    onChange={(e) => {
                      setIsBlankForm(e.target.checked);
                    }}
                    checked={isBlankForm}
                  />
                  <Form.Label>Is blank form?</Form.Label>
                </div>
                <Button
                  variant="primary"
                  className="btn-blue w-140 mb-4"
                  onClick={() => {
                    setFormInputFlag(true);
                    generateQRcode();
                  }}
                >
                  Generate QR Code
                </Button>
              </form>
            ) : (
              <div className="HpQrcode text-center">
                <QRCode
                  value={qValue}
                  size={qSize}
                  // bgColor={qBgColor}
                  // logoImage={Logo}
                  logoHeight={qLogoHeight}
                  logoWidth={qLogoWidth}
                />
              </div>
            )}
          </div>
        </Modal.Body>
        {formInputFlag && (
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => handleClick()}
            >
              Download QR Code
            </Button>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => {
                setFormInputFlag(false);
                handleCloseQRcodePrompt();
              }}
            >
              Cancel
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  { generateQRcodeAction }
)(GenerateQRcode);
